export default __webpack_public_path__ + "static/media/anaerobic-respiration.c42b4070.jpg";